class NavigationScroll {
    constructor(browser) {
        this.browser = browser;
        this.positions = new Map();
        this.index = null;
        this.target = { x: 0, y: 0 };
    }

    init() {
        this.index = this.browser.history.state?.index;
    }

    before(trigger) {
        const body = this.browser.document.body;
        // Android's scroll lock fixes the body and temporarily resets window.scrollY.
        const y = body.style.position === 'fixed'
            ? Math.max(0, -(parseFloat(body.style.top) || 0))
            : this.browser.scrollY;

        if (this.index != null) {
            this.positions.set(this.index, { x: this.browser.scrollX, y });
        }

        this.init();
        const isHistoryNavigation = trigger === 'back' || trigger === 'forward';
        this.target = isHistoryNavigation
            ? this.positions.get(this.index) || { x: 0, y: 0 }
            : { x: 0, y: 0 };
    }

    apply() {
        this.browser.scrollTo({
            left: this.target.x,
            top: this.target.y,
            behavior: 'instant',
        });
    }
}

export default NavigationScroll;
